import { render } from "./OnboardingScreen.vue?vue&type=template&id=0187472c"
import script from "./OnboardingScreen.vue?vue&type=script&lang=js"
export * from "./OnboardingScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__